export async function fetchRosreestrObjectCardStructureByCategoryId(objectTypeId: any) {
    try {
        let url = `https://nspd.gov.ru/api/geoportal/v1/geom-card-display-settings/${objectTypeId}`
        const response: any = await fetch(url, {
            method: 'GET'
        });
        if (!response.ok) {
            throw new Error('Failed to fetch');
        } else {
            let rosreestrObjectCardStructure = await response.json()
            const { card: cardStructure, title: titleStructure } = rosreestrObjectCardStructure
            return { cardStructure, titleStructure }
        }
    } catch (error) {
        console.error('Fetch error:', error);
    }
}